import { render } from "./VatField.vue?vue&type=template&id=97e2db36"
import script from "./VatField.vue?vue&type=script&lang=js"
export * from "./VatField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__